import React, { useEffect, useState, useRef, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import axios from 'util/axios';
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import DataTable from "./DataTables";
import DescriptionRender from "./Description";
import SOTable from "./SOTable";
import { t } from "i18next";

import diff_match_patch from "../Functions/diff-match-patch";

const TableContainer = (props) => {
    const [Hide, SetHide] = useState(false);
    const HandleSetHide = () => {
        SetHide((OLD) => {
            return !OLD;
        });
    };

    return (
        <div className={"table-container" + (Hide ? " hide" : "")}>
            <h1 className="title" onClick={HandleSetHide}>
                {props.title.toString()} <FontAwesomeIcon icon={faAngleUp} />
            </h1>
            <div className="table-container-inner">{props.children}</div>
        </div>
    );
};

const DescContainer = (props) => {
    const [Hide, SetHide] = useState(false);
    const HandleSetHide = () => {
        SetHide((OLD) => {
            return !OLD;
        });
    };

    return (
        <div className={"desc-container" + (Hide ? " hide" : "")}>
            <h1 className="title" onClick={HandleSetHide}>
                {props.title.toString()} <FontAwesomeIcon icon={faAngleUp} />
            </h1>
            <div className="desc-container-inner">{props.children}</div>
        </div>
    );
};

const SOContainer = (props) => {
    const { soData, selectedSO, setSelectedSO } = props;

    const ScrollRef = useRef(null);

    const ScrollMove = (direction) => {
        let move = 450;
        if (direction === "left") {
            move = move * -1;
        }
        ScrollRef.current.scrollLeft += move;
    };

    const OnClickSO = (index) => {
        setSelectedSO(index);
    };

    return (
        <div className="info_bottom">
            <div className="left">
                <ul className="arrow">
                    <li onClick={() => ScrollMove("left")}>{"<"}</li>
                </ul>
                <ul className="tap" ref={ScrollRef}>
                    <li onClick={() => OnClickSO(-1)} className={selectedSO === -1 ? "on" : ""}>
                        All
                    </li>
                    {soData.map((v, i) => {
                        return (
                            <li
                                key={i}
                                className={selectedSO === i ? "on" : ""}
                                onClick={() => OnClickSO(i)}
                            >
                                {v.description}
                            </li>
                        );
                    })}
                </ul>
                <ul className="arrow">
                    <li onClick={() => ScrollMove("right")}>{">"}</li>
                </ul>
            </div>
        </div>
    );
};

const RenderTables = (props) => {
    const { tableData } = props;

    const dispatch = useDispatch();

    const getSheetDetailInfo = async (arg) => {
        dispatch({ type: "LOADING_ON" });
        try {
            const res = await axios
                .post(process.env.REACT_APP_API + "/diff/revision", arg.data)
                .then((Response) => {
                    return Response.data.data.result;
                });
            arg?.setState(res);
        } catch (e) {
            console.error(e);
        } finally {
            dispatch({ type: "LOADING_OFF" });
            if (arg.compare) {
                getCompareData(true);
            } else {
                getCompareData(false);
            }
        }
    };

    const getCompareData = async (compare) => {
        dispatch({ type: "LOADING_ON" });
        try {
            let response = null;
            if (compare) {
                const { sheetcd, left, right } = tableData;

                response = await axios
                    .post(process.env.REACT_APP_API + "/diff/revisionDiff", {
                        sheetcd: sheetcd,
                        revision: left.toString().replaceAll(/\D+/g, ""),
                        revisionTemp: left.toString().includes("T") ? "Y" : "N",
                        revision2: right.toString().replaceAll(/\D+/g, ""),
                        revision2Temp: right.toString().includes("T") ? "Y" : "N",
                    })
                    .then((Response) => {
                        return Response.data.data.result;
                    });
            }
            SetRightData((Data) => ({ ...Data, compare: response }));
        } catch (e) {
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    };

    const [RightData, SetRightData] = useState({});

    useEffect(() => {
        const { right, compare, sheetcd } = tableData;
        if (right !== undefined) {
            getSheetDetailInfo({
                data: {
                    sheetcd,
                    revision: right.toString().replaceAll(/\D+/g, ""),
                    tempYn: right.toString().includes("T") ? "Y" : "N",
                },
                setState: SetRightData,
                compare: compare,
            });
        }

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.tableData?.right, props?.tableData?.compare]);

    useEffect(() => {
        // if (RightData?.sub) {
        //     const so = RightData.sub;
        //     SetSOData(so);
        // }
        if (RightData?.master?.webContent) {
        }
    }, [RightData]);

    return (
        <>
            <section className="detail2-renderTable">
                {!RightData?.in ? (
                    <div></div>
                ) : (
                    <>
                        <DescContainer title="Description">
                            <DescriptionRender
                                data={RightData}
                            />
                        </DescContainer>
                        {RightData?.composition?.length > 0 && (
                            <TableContainer title="Composition">
                                <div className="right" data-tabletype="COMPOSITION">
                                    {!!RightData?.composition && (
                                        <DataTable _tblData={RightData} type="composition" />
                                    )}
                                </div>
                            </TableContainer>
                        )}

                        <TableContainer title="IN">
                            <div className="right" data-tabletype="IN">
                                {!!RightData?.in && <DataTable _tblData={RightData} type="in" />}
                            </div>
                        </TableContainer>
                        <TableContainer title="OUT">
                            <div className="right" data-tabletype="OUT">
                                {!!RightData?.out && <DataTable _tblData={RightData} type="out" />}
                            </div>
                        </TableContainer>
                        <TableContainer title="QC">
                            <div className="right" data-tabletype="QC">
                                {!!RightData?.qc && <DataTable _tblData={RightData} type="qc" />}
                            </div>
                        </TableContainer>
                    </>
                )}
            </section>
        </>
    );
};

// const isEquals = (prev, next) => {
//     return JSON.stringify(prev) === JSON.stringify(next);
// };

// export default React.memo(RenderTables, isEquals);
export default RenderTables;
